import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../images/clean-your-lists-transparent-logo.png";
import { resendActivationHandleChange } from "../../common/actions";
import { resendActivationAction } from "../../Containers/Login/actions";
import Overlay from "../../utility/overlay";
import {parse as parseUrl} from "qs";
import {
  forgotPasswordValidators,
  updateValidators,
  initValidations
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";

const mapStateToProps = state => ({
  resendActivationInfo: state.resendActivationInfo
});
class ResendActivation extends Component {
  constructor() {
    super();

    this.state = { showErrorSummary: false };
    this.validators = forgotPasswordValidators;

    initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.props.dispatch(
      resendActivationHandleChange(event.target.name, event.target.value)
    );
    updateValidators(this.validators, event.target.name, event.target.value);
  }

  //Clearing the textbox value on page load
  componentDidMount() {
    if(this.props.location.state){
      const {username} = this.props.location.state
      if(username){
        this.props.dispatch(resendActivationHandleChange("username", username ? username : ""));
        updateValidators(this.validators, "username", username);
      }
    }
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });

    if (this.validators.errorSummary.length == 0) {
      const { username } = this.props.resendActivationInfo;
      this.props.dispatch(resendActivationAction({ username }));
    }
  }
  render() {
    return (
      <div className="login full-height">
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}

        {this.props.resendActivationInfo.btnDisabled ? <Overlay /> : null}
        <div className="login_wrapper">
          <div className="animate form login_form">
            <div className="text-center">
              <h1>
                <a href="https://cleanyourlists.com" target="_blank">
                  <img src={logo} alt="logo" style={{width:300}} />
                </a>
              </h1>
            </div>
            <section className="login_content">
              <form style={{ marginBottom: 0 }} onSubmit={this.handleSubmit}>
                <h1> Resend Activation </h1>
                <div className="form-label">
                  Your registered email address
                  <span className="required-label">*</span> <br />
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    onChange={this.handleChange}
                    value={this.props.resendActivationInfo.username}
                  />
                </div>

                <div className="col-md-6 text-left" style={{paddingLeft:0}}>
                  <button className="btn btn-default btn-primary" type="submit">
                    Send Activation Link
                  </button>
                </div>

                <div className="clearfix" />

                <div className="separator">
                  <p className="change_link">
                    <Link to="/login" className="to_register">
                      {" "}
                      Go to Login page
                    </Link>
                  </p>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ResendActivation);



// WEBPACK FOOTER //
// ./src/components/Login/ResendActivation.js